import { RouteRecordRaw } from 'vue-router';
import NoHeaderLayout from '@/components/layout/NoHeaderLayout.vue';

const defaultPath = '/leads';

const routes: Array<RouteRecordRaw> = [
  {
    path: `/${defaultPath}/join`,
    name: 'LeadsJoinPage',
    component: () => import(/* webpackChunkName: "leads" */ '@/views/leads/JoinView.vue'),
    meta: {
      layout: NoHeaderLayout,
      accessWithSession: undefined,
    },
  },
];

export default routes;
